
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0ea7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0ea7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $80d223eb5f58a298$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["fgLMT","index.38542f6a.js","39Aki","sprite.f0725d09.svg","jlPPJ","autosai_logo.99640ed2.svg","lLttp","404.3f789470.svg","aPIs9","auto-sai_QR.3e455f0e.png"]'));

var $65dd9c7df9544469$exports = {};
$65dd9c7df9544469$exports = new URL("sprite.f0725d09.svg", import.meta.url).toString();


class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    render(locale) {
        const titleStr = locale ? "Auto SAI | Welcome" : "Auto SAI | Bienvenue";
        document.title = titleStr;
        const markup = this._generateMarkup(locale);
        this.clear();
        this._parentElement.innerHTML = markup;
    }
    renderSpinner() {
        this._clear();
        this._parentElement.innerHTML = `
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    `;
    }
    clear() {
        this._parentElement.innerHTML = "";
    }
    fetchDate() {
        const date = new Date();
        return date;
    }
}



var $9eae982557ccfb5a$exports = {};
$9eae982557ccfb5a$exports = new URL("autosai_logo.99640ed2.svg", import.meta.url).toString();


class $20a0d42f295cccee$var$NavbarView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".navbar");
    _overlay;
    constructor(){
        super();
        this.addHandlerClick();
        this._overlay = document.querySelector(".overlay");
    // window.addEventListener('DOMContentLoaded', function () {
    //   _overlay = document.querySelector('.overlay');
    // });
    }
    addHandlerRender(handler) {
        [
            "hashchange",
            "load"
        ].forEach((ev)=>window.addEventListener(ev, handler));
    }
    addHandlerClick() {
        this._parentElement.addEventListener("click", this._handleNavbarClick.bind(this));
    }
    _handleNavbarClick(e) {
        if (e.target.closest(".menu-ham")) this._toggleMenu();
    }
    _toggleMenu() {
        const menuHam = document.querySelector(".menu-ham");
        const navList = document.querySelector(".navbar__nav-list");
        menuHam.classList.toggle("active");
        navList.classList.toggle("navbar__nav-list--active");
        this._overlay.classList.toggle("overlay--active");
    }
    _generateMarkup(locale) {
        const isEng = locale;
        return `
    <div class="container">
    <div class="navbar__bg"></div>
    <div class="navbar__logo-box">
      <a href="${isEng ? "#en" : "#fr"}" rel="noreferrer"><img class="logo-sai" src="${0, (/*@__PURE__*/$parcel$interopDefault($9eae982557ccfb5a$exports))}" alt="logo image"></a>
      <div>
        <span class="navbar__nav-sub-heading">
        ${isEng ? "General mechanic" : "M&eacute;canique g&eacute;n&eacute;rale"}        
        </span>
      </div>
    </div>
    <a href="#" class="menu-ham" rel="noreferrer">
      <span class="line line-1"></span>
      <span class="line line-2"></span>
      <span class="line line-3"></span>
    </a>
    <ul class="navbar__nav-list">
      <li class="navbar__nav-list--contact">
        <a href="mailto:autosaiinc@gmail.com" rel="noreferrer">
          <svg class="icon icon-mail--navbar">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-mail"></use>
          </svg>
          ${isEng ? "CONTACT US" : "CONTACTEZ-NOUS"}       
        </a>
      </li>
      <li class="navbar__nav-list--lang">
        <a class="navbar__nav-list--lang-link" href="${isEng ? "#fr" : "#en"}" rel="noreferrer">
          <svg class="icon icon-french">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-${isEng ? "french" : "eng"}"></use>
          </svg>${isEng ? "FR" : "EN"}</a>
      </li>
    </ul>
  </div>
    `;
    }
}
var $20a0d42f295cccee$export$2e2bcd8739ae039 = new $20a0d42f295cccee$var$NavbarView();




var $b34dd21f4f50e243$exports = {};
$b34dd21f4f50e243$exports = new URL("404.3f789470.svg", import.meta.url).toString();


var $5473a74700ea99b7$exports = {};
$5473a74700ea99b7$exports = new URL("auto-sai_QR.3e455f0e.png", import.meta.url).toString();


class $986bb538711ab77c$var$RootView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#root");
    _generateMarkup(lang) {
        const isEng = lang;
        return `
    <header class="header">
    <div class="container">
      <div class="header__heading-box">
        <h1 class="header__heading-primary">
          ${isEng ? "We are strongly committed in exceeding your expectations at a very competitive price, since 2011" : "Nous sommes fortement engag&eacute;s &agrave; d&eacute;passer vos attentes, tout en ayant un prix tr&egrave;s comp&eacute;titif, depuis 2011"}
          <br>
          <span class="header__vector-line">
            <svg ${!isEng ? 'class="fr"' : ""}width="100%" height="100%" viewbox="0 0 202 29">
              <path d="M6 23C6 23 14.8837 19.0243 71.7395 11.9999C128.595 4.97555 197 5 197 5" stroke="white"
                stroke-width="10" stroke-linecap="round"></path>
            </svg>
          </span>
        </h1>
        <h1 class="header__heading-primary--sub">
          ${isEng ? "Need an appointment today?" : "Besoin d'un rendez-vous aujourd'hui?"}
        </h1>
        <a class="btn btn-cta u-mt-md" href="https://calendly.com/autosaiinc/" rel="noreferrer">
          <span>
            <svg class="icon icon-phone">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-phone"></use>
            </svg>
            ${isEng ? "Book Appointment" : "Prendre un rendez-vous"}
          </span>
        </a>
      </div>
    </div>
    <div class="container__img-box">
      <ul class="slideshow">
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
  </header>

  <main>
    <section class="section section-services">
      <div>
        <div class="section-heading__wrapper">
          <h2 class="section-heading gs_reveal gs_reveal_fromLeft">
            ${isEng ? "OUR SERVICES" : "NOS SERVICES"}
          </h2>
        </div>
        <span class="gs_reveal gs_reveal_fromLeft">
          ${isEng ? "We have the tools and equipment to work on a wide range of vehicule makes and models." : "Nous disposons des outils et de l'&eacute;quipement n&eacutec&eacute;ssaire pour travailler sur un large &eacute;ventail de marques et de mod&egrave;les."}
        </span>
      </div>
      <div class="container gs_reveal gs_reveal_fromLeft">
        <div class="services-card c1">
          <h3 class="services-card__heading">
            <svg class="icon icon-services">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-repair"></use>
            </svg>
            ${isEng ? "Repairs" : "R\xe9parations"}
            
          </h3>
          <div class="services-card__list-box">
            <ul class="list">
              <li class="list__item">Suspension</li>
              <li class="list__item">${isEng ? "Brakes" : "Freins"}</li>
              <li class="list__item">${isEng ? "Body work" : "Carrosserie"}</li>
              <li class="list__item">${isEng ? "Muffler" : "Silencieux (muffler)"}</li>
            </ul>
          </div>
        </div>

        <div class="services-card c2">
          <h3 class="services-card__heading">
            <svg class="icon icon-services">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-oil"></use>
            </svg>
            Maintenance
          </h3>
          <div class="services-card__list-box">
            <ul class="list">
              <li class="list__item">${isEng ? "Oil change" : "Changement d'huile"}</li>
              <li class="list__item">${isEng ? "Transmission flush" : "Rin&ccedil;age de transmission"}</li>
              <li class="list__item">${isEng ? "Coolant flush" : "Rin&ccedil;age du r&eacute;frig&eacute;rant"}</li>
              <li class="list__item">${isEng ? "Rust proofing" : "Antirouille"}</li>
            </ul>
          </div>
        </div>

        <div class="services-card c3">
          <h3 class="services-card__heading">
            <svg class="icon icon-services">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-tire"></use>
            </svg>
            ${isEng ? "Tires" : "Pneus"}
          </h3>
          <div class="services-card__list-box">
            <ul class="list">
              <li class="list__item">${isEng ? "Mount and balance" : "Montage et balancement"}</li>
              <li class="list__item">${isEng ? "Tire storage" : "Rangement de pneus"}</li>
              <li class="list__item">${isEng ? "Repairs (patching)" : 'R&eacute;parations "patching"'}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-reviews">
      <div class="container">
        <div class="section-heading__wrapper gs_reveal gs_reveal_fromLeft">
          <h2 class="section-heading">${isEng ? "WHAT OUR CUSTOMERS SAY" : "CE QUE DISENT NOS CLIENTS"}</h2>
        </div>

        <div class="elfsight-app-a17f1f84-e41c-4232-8ad4-ea2ef13ba91e gs_reveal gs_reveal_fromRight"></div>
        <div class="tagembed-container" style=" width:100%;height:100%;overflow: auto;"><div class="tagembed-socialwall" data-wall-id="2880" view-url="https://widget.tagembed.com/2880?view"></div><script src="//widget.tagembed.com/embed.min.js" type="text/javascript"></script></div>
      </div>
    </section>

    <section class="section section-map">
      <div class="section-map__left-bg"></div>
      <div class="section-map__right-bg"></div>
      <div class="container">
        <div class="section-map__left-box">
          <h2 class="section-heading__light">
            <svg class="section-map__icon" width="100%" height="100%" viewbox="0 0 65 59">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-map"></use>
            </svg>
            ${isEng ? "WHEN & WHERE TO FIND US" : "QUAND ET O&Ugrave; NOUS TROUVER"}
            
          </h2>
          <div class="section-map__hours">
            <div class="section-map__weekdays">
              <table class="section-map__table">
                <tr>
                  <td>${isEng ? "Monday:" : "Lundi"}</td>
                  <td>8:00am -</td>
                  <td>&nbsp;5:00pm</td>
                </tr>
                <tr>
                  <td>${isEng ? "Tuesday:" : "Mardi"}</td>
                  <td>8:00am -</td>
                  <td>&nbsp;5:00pm</td>
                </tr>
                <tr>
                  <td>${isEng ? "Wednesday:" : "Mercredi"}</td>
                  <td>8:00am -</td>
                  <td>&nbsp;5:00pm</td>
                </tr>
                <tr>
                  <td>${isEng ? "Thursday:" : "Jeudi"}</td>
                  <td>8:00am -</td>
                  <td>&nbsp;5:00pm</td>
                </tr>
                <tr>
                  <td>${isEng ? "Friday:" : "Vendredi"}</td>
                  <td>8:00am -</td>
                  <td>&nbsp;5:00pm</td>
                </tr>
                <tr>
                  <td>${isEng ? "Saturday:" : "Samedi"}</td>
                  <td>8:00am -</td>
                  <td>&nbsp;2:00pm</td>
                </tr>
                <tr>
                  <td>${isEng ? "Sunday:" : "Dimanche"}</td>
                  <td>${isEng ? "Closed" : "Ferm\xe9"}</td>
                  <td></td>
                </tr>
              </table>
            </div>
          </div>
          <a class="btn btn-cta u-mb-lg u-mt-md" href="tel:5145383555" rel="noreferrer">
            <span>
              <svg class="icon icon-phone" viewbox="0 0 24 24">
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-phone"></use>
              </svg>
              (514) 538-3555
            </span>
          </a>
        </div>

        <div class="section-map__google-map gs_reveal gs_reveal_fromRight">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2797.3183465185184!2d-73.77800868370494!3d45.483533740172874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc93dac1384f141%3A0x9ae4a4e44b72959d!2sAuto%20Sai%20Inc!5e0!3m2!1sen!2sca!4v1616419097849!5m2!1sen!2sca"
            width="100%" height="100%" style="border:0;
" allowfullscreen="" loading="lazy"></iframe>
        </div>
      </div>
    </section>
  </main>
  <div class="overlay"></div>
    `;
    }
}
var $986bb538711ab77c$export$2e2bcd8739ae039 = new $986bb538711ab77c$var$RootView();




class $56269c541bd5c3f7$var$FooterView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".section-footer");
    _generateMarkup(lang) {
        const isEng = lang;
        return `
    <div class="container gs_reveal gs_reveal_fromLeft">

      <div class="footer__outer-box">

        <svg class="logo-sai logo-sai--footer">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#logo-sai"></use>
        </svg>

        <h2 class="u-mb-md">
        ${isEng ? "Proudly serving automobilists in the Montreal area since 2011." : "Fier de servir les automobilistes dans la r&eacute;gion de Montr&eacute;al depuis 2011."}
          
        </h2>

        <ul class="footer__left-list">
          <li><svg class="icon icon-pin">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-pin"></use>
            </svg>
            556 Michel Jasmin Ave, Dorval, Quebec, H9P 1C4
          </li>
          <li>
            <svg class="icon icon-mail">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-mail"></use>
            </svg>
            <a href="mailto:autosaiinc@gmail.com">&nbsp;
              autosaiinc@gmail.com</a><span>&nbsp;&larr;&nbsp;
              ${isEng ? "questions, comments or anything else?" : "questions, commentaires ou autre chose?"}
              </span>
          </li>
        </ul>

        <div class="footer__socials">
          <a class="footer__socials-link" href="https://www.facebook.com/Auto-sai-102231161667660" target="_blank" rel="noopener noreferrer">
            <svg class="icon icon-socials">
              <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-fb"></use>
            </svg>
          </a>
          <a class="footer__socials-link" href="#">
            <svg class="icon icon-socials">
              <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-twitter"></use>
            </svg>
          </a>
          <a class="footer__socials-link" href="#">
            <svg class="icon icon-socials">
              <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($65dd9c7df9544469$exports))}#icon-insta"></use>
            </svg>
          </a>
        </div>
      </div>


      <div class="footer__copyright">
        <span>&copy; Copyright <span class="year">${this.fetchDate().getFullYear()}</span> Auto Sai</span>
      </div>
    </div>
    `;
    }
}
var $56269c541bd5c3f7$export$2e2bcd8739ae039 = new $56269c541bd5c3f7$var$FooterView();


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    isEng: true
};
const $0f1d4402dffacf5b$var$fetchLang = ()=>{
    const locale = navigator.language;
    const [str] = locale.split("-");
    if (str === "fr") {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.isEng = false;
        document.title = "Auto SAI | Bienvenue";
    } else document.title = "AUTO SAI | Welcome";
};
const $0f1d4402dffacf5b$var$init = function() {
    $0f1d4402dffacf5b$var$fetchLang();
};
// const observe = function (entries, observer) {
//   entries.forEach(function (entry) {
//     if (entry.intersectionRatio > 0) {
//       const img = entry.target;
//       const src = img.dataset.src;
//       const srcset = img.dataset.srcset;
//       requestIdleCallback(function () {
//         if (srcset) {
//           img.srcset = srcset;
//         }
//         img.src = src;
//       });
//       observer.unobserve(img);
//     }
//   });
// };
// export const observer = new IntersectionObserver(observe, {});
$0f1d4402dffacf5b$var$init();


"use strict";
const $f50bd1f2915ed0f2$var$controlNavbarView = function() {
    let state = $0f1d4402dffacf5b$export$ca000e230c0caa3e.isEng;
    const hash = window.location.hash.slice(1);
    if (hash === "en") state = true;
    if (hash === "fr") state = false;
    [
        (0, $20a0d42f295cccee$export$2e2bcd8739ae039),
        (0, $986bb538711ab77c$export$2e2bcd8739ae039),
        (0, $56269c541bd5c3f7$export$2e2bcd8739ae039)
    ].forEach((elem)=>elem.render(state));
    gsap.utils.toArray(".gs_reveal").forEach(function(elem) {
        $f50bd1f2915ed0f2$var$hide(elem); // assure that the element is hidden when scrolled into view
        ScrollTrigger.create({
            trigger: elem,
            start: "top 80%",
            // markers: true,
            once: true,
            onEnter: function() {
                $f50bd1f2915ed0f2$var$animateFrom(elem);
            }
        });
    });
};
// gsap animation #1 //////////////////////////////////////////
const $f50bd1f2915ed0f2$var$hide = function(elem) {
    gsap.set(elem, {
        autoAlpha: 0
    });
};
const $f50bd1f2915ed0f2$var$animateFrom = function(elem, direction) {
    direction = direction || 1;
    let x = 0, y = direction * 100;
    if (elem.classList.contains("gs_reveal_fromLeft")) {
        x = -100;
        y = 0;
    } else if (elem.classList.contains("gs_reveal_fromRight")) {
        x = 100;
        y = 0;
    } else if (elem.classList.contains("gs_reveal_fromBottom")) {
        x = 0;
        y = 100;
    }
    elem.style.transform = `translate(${x}px, ${y}px')`;
    elem.style.opacity = "0";
    gsap.fromTo(elem, {
        x: x,
        y: y,
        autoAlpha: 0
    }, {
        duration: 2.25,
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: "expo",
        overwrite: "auto"
    });
};
document.addEventListener("DOMContentLoaded", function() {
    gsap.registerPlugin(ScrollTrigger);
});
const $f50bd1f2915ed0f2$var$init = function() {
    (0, $20a0d42f295cccee$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlNavbarView);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.38542f6a.js.map
